import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";
import { PlusIcon } from "@eisox/icons";

import { cn } from "..";

const NumberFieldIncrement = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithRef<typeof BaseNumberField.Increment>
>((props, forwardedRef) => {
  const { className, children, ...incrementProps } = props;
  return (
    <BaseNumberField.Increment
      {...incrementProps}
      ref={forwardedRef}
      className={cn(
        "w-11 flex cursor-pointer items-center justify-center border-none bg-transparent text-primary-dark-gray transition-colors",
        "hover:bg-primary-gray hover:text-primary-dark-blue disabled:cursor-not-allowed disabled:bg-transparent disabled:opacity-50",
        "[&>svg]:h-4 [&>svg]:w-4",
        className,
      )}
    >
      {children ?? <PlusIcon />}
    </BaseNumberField.Increment>
  );
});

NumberFieldIncrement.displayName = "NumberField.Increment";

export default NumberFieldIncrement;
